// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f6051a71","498":"83e66d00","703":"ae71d6a9","789":"c559135e"}[chunkId] + ".chunk.js";
};